import comp from "./KeyConcepts";
export default comp;
